import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import Spinner from "components/common/Spinner"
import GuestEmailVerifyModal from "components/GuestEmailVerifyModal"
import GuestHeader from "layoutsV2/client/GuestHeader"
import { useTitle } from "hooks/useTitle"

import { useDispatch, useSelector } from "react-redux"
import { cleanBooking, getBooking } from "store/bookings"
import { cleanTrip, receivedTrip } from "store/trips"
import { TripsPreview } from "components/trips/TripsPreview"
export default function BookingTrip() {
  const params = useParams()
  const dispatch = useDispatch()
  const { booking } = useSelector((store) => store.bookings)
  const { authorized } = useSelector((store) => store.guestAccess)
  const { trip, loading } = booking
  const [refreshTrigger, setRefreshTrigger] = React.useState(0)
  const isLoggedIn = !!localStorage.getItem('access_token')
  const hasGuestToken = !!localStorage.getItem('guest_token')
  const needsAuthorization = !isLoggedIn && !hasGuestToken && !authorized
  useTitle(trip?.title)

  // Listen for custom event when authorization completes
  useEffect(() => {
    const handleAuthSuccess = () => {
      setRefreshTrigger(prev => prev + 1)
    }
    window.addEventListener('guestAuthSuccess', handleAuthSuccess)
    return () => window.removeEventListener('guestAuthSuccess', handleAuthSuccess)
  }, [])

  useEffect(() => {
    dispatch(getBooking(params.uuid, true, false, true))
      .then(({ trip }) => dispatch(receivedTrip(trip)))
    return () => dispatch(cleanBooking()) && dispatch(cleanTrip())
  }, [params.uuid, refreshTrigger]) //eslint-disable-line

  if (needsAuthorization) {
    return <GuestEmailVerifyModal bookingUuid={params.uuid} />
  }

  if (loading) return <Spinner />

  return (
    <main className="vstack min-vh-100 bg-light">
      <GuestHeader hideUserControls={hasGuestToken} />
      <div className="flex-fill vstack min-h-100 py-15 px-80">
        {booking.id && <TripsPreview />}
      </div>
    </main>
  )
}
